import React, { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom';
import { IoMdSend } from "react-icons/io";
import { host } from './script/variables';
import './style/RplyComp.css';

const RplyComp = () => {
  const [params] = useSearchParams()
  const [parentNode, setParentNode] = useState(null)
  const [rplyInp, setRplyInput] = useState('')
  const [rply, setRply] = useState([])
  const [user, setUser] = useState()
  const [openReplyId, setOpenReplyId] = useState(null) // which inner-reply box is open
  const [firstTime, setFirstTime] = useState(true)

  const isLogin = true
  const cafeId = params.get('cid')
  const parentId = params.get('pid')
  const pageSize = 5
  const pageNo = 1

  function timeAgo(timestamp) {
    const currentTime = new Date();
    const previousTime = new Date(timestamp);
    const seconds = Math.floor((currentTime - previousTime) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);

    if (months > 0) return months === 1 ? '1 month' : months + ' months';
    if (weeks > 0) return weeks === 1 ? '1 week' : weeks + ' weeks';
    if (days > 0) return days === 1 ? '1 day' : days + ' days';
    if (hours > 0) return hours === 1 ? '1 hour' : hours + ' hours';
    if (minutes > 0) return minutes === 1 ? '1 minute' : minutes + ' minutes';
    return seconds <= 5 ? 'just now' : seconds + ' seconds';
  }

  const addRply = async (comId, repliedto, repliedToName) => {
    if (!isLogin) {
      alert("Login to add reply")
      return
    }
    if (!rplyInp.trim()) return

    const payload = {
      postID: cafeId,
      depth: 1,
      parentID: comId,
      commentText: rplyInp,
      repliedTo: repliedto,
      repliedToName: repliedToName
    }

    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${host}/actions/comment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const data = await response.json();
        const newComment = {
          _id: data.resp._id,
          postID: cafeId,
          depth: 1,
          parentID: comId,
          authorName: [user?.givenName, user?.familyName].filter(Boolean).join(' '),
          authorEmail: user?.email,
          authorImage: user?.imageUrl,
          commentText: rplyInp,
          repliedTo: repliedto,
          createdAt: new Date().toISOString(),
          repliedToName: repliedToName
        }

        setRply([newComment, ...rply])
        setRplyInput('')
        setOpenReplyId(null)
      } else {
        console.error('Error:', response.statusText);
      }
    } catch (error) {
      console.error("Error ", error)
    }
  }

  const fetchCommentTree = async () => {
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${host}/masala/ctree1?cid=${cafeId}&pid=${parentId}&ps=${pageSize}&pno=${pageNo}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setRply(prev => [...prev, ...data])
      }
    } catch (error) {
      console.log('error in fetching comment tree')
    }
  }

  const fetchCommentTreePnode = async () => {
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${host}/masala/ctreePnode1?cid=${cafeId}&pid=${parentId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setParentNode(data[0])
      }
    } catch (error) {
      console.log('error in fetching parent node')
    }
  }

  const fetchRply = async (l, parentID) => {
    const token = localStorage.getItem('token')
    const response = await fetch(`${host}/actions/rply?pid=${parentID}&l=${l}&il=${isLogin}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${token}`
      }
    });

    if (response.ok) {
      const data = await response.json();
      console.log(data)
    } else {
      console.error('Error:', response.statusText);
    }
  }

  const toggleInnerReply = (replyId) => {
    setRplyInput('')
    setOpenReplyId(prev => (prev === replyId ? null : replyId))
  }

  useEffect(() => {
    fetchCommentTreePnode()
    const storedUser = JSON.parse(localStorage.getItem('cafeuser'))
    setUser(storedUser)
    if (firstTime) {
      fetchCommentTree()
      setFirstTime(false)
    }
  }, [])

  if (!parentNode) return null

  return (
    <div className="reply-page">
      <Link to={`/moredetails?cafeid=${cafeId}`} className="back-link">
        ← Back to cafe
      </Link>

      <div className="comment-card comment-card--root">
        <img
          className="avatar"
          src={parentNode.authorImage}
          alt={parentNode.authorName}
        />
        <div className="comment-body">
          <div className="comment-meta">
            <span className="comment-author">@{parentNode.authorName}</span>
            <span className="comment-time">{timeAgo(parentNode.createdAt)}</span>
          </div>
          <p className="comment-text">{parentNode.commentText}</p>

          <div className="reply-thread">
            {rply.map((repl) => (
              <div className="comment-card comment-card--reply" key={repl._id}>
                <img
                  className="avatar avatar--sm"
                  src={repl.authorImage}
                  alt={repl.authorName}
                />
                <div className="comment-body">
                  <div className="comment-meta">
                    <span className="comment-author">@{repl.authorName}</span>
                    <span className="comment-time">{timeAgo(repl.createdAt)}</span>
                  </div>
                  <p className="comment-text">
                    {repl.repliedToName && (
                      <span className="reply-tag">@{repl.repliedToName} </span>
                    )}
                    {repl.commentText}
                  </p>

                  <button
                    type="button"
                    className="reply-toggle"
                    onClick={() => toggleInnerReply(repl._id)}
                  >
                    {openReplyId === repl._id ? 'Cancel' : 'Reply'}
                  </button>

                  {openReplyId === repl._id && (
                    <div className="reply-input-row">
                      <textarea
                        className="reply-input"
                        value={rplyInp}
                        onChange={(e) => setRplyInput(e.target.value)}
                        placeholder={`Reply to @${repl.authorName}...`}
                        rows={1}
                      />
                      <button
                        type="button"
                        className="send-btn"
                        onClick={() => addRply(parentNode._id, repl.authorEmail, repl.authorName)}
                        aria-label="Send reply"
                      >
                        <IoMdSend />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}

            {parentNode.level !== 0 && parentNode.replyCount - parentNode.level * 3 > 0 && (
              <button
                type="button"
                className="load-more"
                onClick={() => fetchRply(parentNode.level, parentNode._id)}
              >
                {parentNode.replyCount - parentNode.level * 3} more replies
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RplyComp